/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

import wx from 'weixin-js-sdk'
const Method = {
  NAVIGATETO: 'navigateTo',
  REDIRECTTO: 'redirectTo',
  RELAUNCH: 'reLaunch',
  SWITCHTAB: 'switchTab',
};

const systemQueryKeys = ['smartcode', 'sourcecode', 'sc'];

const helper = {
  queryToString(obj) {
    const keys = Object.keys(obj);
    const newArgs = {};
    keys.forEach((key) => {
      newArgs[key] = obj[key];
    });
    let string = '';
    for (const k in newArgs) {
      string += `&${k}=${newArgs[k]}`;
    }
    string = string.substr(1);
    return string;
  },
  stringToQuery(str) {
    return str.split('&').reduce((prev, cur) => {
      const [key, value] = cur.split('=');
      return {
        ...prev,
        [`${key}`]: value,
      };
    }, {});
  },
};

export const getUrlParamObject = () => {
  const url = window.location.search; // 获取url中"?"符后的字串
  const theRequest = {};
  if (url.indexOf('?') !== -1) {
    let strs = [];
    const str = url.substr(1);
    strs = str.split('&');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(
        strs[i].split('=')[1],
      );
    }
  }
  return theRequest;
};

const propertiesToLowerCase = (obj, properties) => {
  const nextObj = {};
  const keys = Object.keys(obj);
  properties.forEach((p) => {
    const key = keys.find((k) => k.toLowerCase() === p.toLowerCase());
    if (key) {
      if (obj[key.toLowerCase()] === undefined) {
        nextObj[key.toLowerCase()] = obj[key];
        delete nextObj[key];
      } else {
        nextObj[key.toLowerCase()] = obj[key];
      }
    }
  });
  return nextObj;
};

/**
 * 获取系统参数
 *
 * @returns {object} 返回系统query参数,比如smartcode
 */
const getSystemQuery = () => {
  const params = getUrlParamObject();
  const query = propertiesToLowerCase(params, systemQueryKeys);
  let sceneQuery = {};
  // 扫码进入
  if (query.scene) {
    sceneQuery = helper.stringToQuery(decodeURIComponent(query.scene));
  }
  sceneQuery = propertiesToLowerCase(sceneQuery, systemQueryKeys);
  return Object.assign(sceneQuery, query);
};

const jump = (options) => {
  const { url, query = {}, method = 'navigateTo' } = options;
  const systemQuery = getSystemQuery();
  const mergedQuery = { ...systemQuery, ...query };
  const stringMergedQuery = helper.queryToString(mergedQuery);

  const nextUrl =
    url.indexOf('?') < 0
      ? `${url}?${stringMergedQuery}`
      : `${url}&${stringMergedQuery}`;
  // eslint-disable-next-line no-undef
  console.log('跳转小程序:',nextUrl);
  wx.miniProgram[method]({
    url: nextUrl,
  });
};

const getMiniProgramEnv = async () => {
  return new Promise((resolve) => {
    // eslint-disable-next-line no-undef
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  });
};
/**
 * 判断是否在小程序环境中
 * @return 返回true|false
 */
export const isInMiniProgram = async () => {
  let result = false;
  const userAgent = navigator.userAgent.toLowerCase();
  const rule = /MicroMessenger/i;
  if (rule.test(userAgent)) {
    // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
    if (typeof wx !== 'undefined') {
      // eslint-disable-next-line no-undef
      if (wx.miniProgram) {
        result = await getMiniProgramEnv();
      }
    }
  }
  return result;
};
/**
 * 从H5页面跳转到小程序原生页面中
 * @param {object} data: app原生页面使用的data对象
 * @return null
 */
export const webToMiniprogram = (params) => {
  try {
    const options = { ...params, method: params.method || Method.NAVIGATETO };
    jump(options);
  } catch (e) {
    console.log(e)
    // TODO handle the exception
  }
};

// 判断是否在抖音
export const isDouyinClient = ()=>{
  var ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/aweme/i) == 'aweme'){
      return true;
  }else{
      return false;
  }
}

export const getSystemInfo = () => {
  const u = navigator.userAgent;
  return {
    // 移动终端浏览器版本信息
    trident: u.indexOf('Trident') > -1, // IE内核
    presto: u.indexOf('Presto') > -1, // opera内核
    webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
    mobile:
      !!u.match(/AppleWebKit.*Mobile/i) ||
      !!u.match(
        /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/,
      ), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
    iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, // 是否iPad
    webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
  };
};

export const webToApp = (data) => {
  try {
    const currentOS = getSystemInfo();
    if (currentOS.ios || currentOS.iPad) {
      window.webkit.messageHandlers.webToApp.postMessage(data);
      return true;
    }
    if (currentOS.android) {
      window.webkit.webToApp(JSON.stringify(data));
      return true;
    }
    return false;
  } catch (e) {
    // TODO handle the exception
    return false;
  }
};


